import { render, staticRenderFns } from "./Deliver.vue?vue&type=template&id=427ab2e1"
import script from "./Deliver.vue?vue&type=script&lang=js"
export * from "./Deliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports